import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Activity } from 'app/company/activities/activities.types';
import { environment } from 'environments/environment';
import { BehaviorSubject, map, Observable, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActivitiesService {
    private _apiLink = environment.apiLink;
    private _activities: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }


    get activities(): Observable<any> {
        return this._activities.asObservable();
    }

    getActivities(): Observable<any> {
        return this._httpClient.get<Activity[]>('api/pages/activities').pipe(
            tap((response: Activity[]) => {
                this._activities.next(response);
            }),
        );
    }

    getAll(
        page: number,
        size: number,
        agentEid?: string | number,
        searchValue?: any,
        isShared?: boolean,
        ownedBy?: { id: number; role: string }
    ) {
        const queryParts: string[] = [
            `offset=${encodeURIComponent(String(page))}`,
            `limit=${encodeURIComponent(String(size))}`,
        ];

        if (agentEid) {
            queryParts.push(`agentEid=${encodeURIComponent(String(agentEid))}`);
        }
        if (searchValue) {
            queryParts.push(`search=${encodeURIComponent(String(searchValue))}`);
        }
        if (isShared === true || isShared === false) {
            queryParts.push(`isShared=${encodeURIComponent(String(isShared))}`);
        }
        if (ownedBy && Number.isFinite(ownedBy.id) && ownedBy.role) {
            queryParts.push(
                `ownedById=${encodeURIComponent(String(ownedBy.id))}`,
                `ownedByRole=${encodeURIComponent(ownedBy.role)}`
            );
        }

        const url = `${this._apiLink}activity/get-activities?${queryParts.join('&')}`;
        return this._httpClient.get(url).pipe(
            map((response: any) => {
                return { data: response.data.activities, count: response.data.count }
            }),
        );
    }

    getDetails(agentEid: string | number, activityId: string | number) {
        return this._httpClient
            .get(this._apiLink + `activity/get-activities/${agentEid}/${activityId}`)
            .pipe(
                map((response: any) => {
                    return response.data.activities;
                }),
            );
    }

    getDetailsByOnlyActivityId(activityId: number) {
        return this._httpClient.get(this._apiLink + `activity/get-activities/${activityId}`).pipe(
            map((response: any) => {
                return response.data.activities
            }),
        );
    }

    getSubActivityData(subId) {
        return this._httpClient.get(this._apiLink + `activity/get-sub-activity-data/${subId}`).pipe(
            map((response: any) => {
                return response.data.subactivity
            }),
        );
    }

    generateReport(modal) {
        return this._httpClient.post(this._apiLink + 'report/generate', modal)
    }


    updateActivityFavoriteStatus(modal) {
        return this._httpClient.put(this._apiLink + 'activity/mark-as-favorite-sub-activity', modal)
    }

    deleteActivity(id) {
        return this._httpClient.delete(this._apiLink + `activity/delete-activity/${id}`)
    }

    shareActivity(body: {
        activityId: number;
        memberIds: number[];
        staffIds: number[];
        userIds: number[];
    }) {
        return this._httpClient.put(this._apiLink + 'activity/share-activity', body);
    }

    markActivityChartAsFavorite(modal) {
        return this._httpClient.put(this._apiLink + 'activity/mark-as-favorite-chart', modal)
    }

    markSubActivityCorrect(payload: {
        activityId: number;
        subActivityId: number;
        reason?: string;
    }) {
        return this._httpClient.put(
            this._apiLink + 'activity/mark-sub-activity-correct',
            payload,
        );
    }

    getQuestionDetails(id) {

    }
}
